import React, { Component } from 'react';
import { graphql } from 'react-apollo';
import { compose, mapProps } from 'recompose';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
// import AddIcon from '@material-ui/icons/PersonAdd';

import AssessmentSubscriber from 'components/threepp/assessment/AssessmentSubscriber';
import AssessmentGuidedTour, { SHOW_ASSESSMENT_GUIDED_TOUR_KEY } from 'components/threepp/assessment/AssessmentGuidedTour/AssessmentGuidedTour';
// import Tooltip from 'components/common/Tooltip/Tooltip';
import Routes from 'utils/routes/appRoutes';
// import AssessmentFilters from 'components/threepp/assessment/Filters/AssessmentFilters';
import { showSuccessMessage, showErrorMessage } from 'components/common/Alert/Alert';
import ConfirmationDialog from 'components/common/Dialog/Dialog';
import LoadingPage from 'components/common/Loader/Spinner/Spinner';
import AssessmentHeader from 'components/threepp/assessment/Header/Header';
import AssessmentFooter from 'components/threepp/assessment/Footer/Footer';
import AssessmentNavBar from 'components/threepp/assessment/NavBar/AssessmentNavBar';
import InviteParticipantModal from 'components/threepp/assessment/InviteParticipantModal/InviteParticipantModal';
import ActionsInfoHeader from 'components/threepp/assessment/ActionsInfo/ActionsInfo';
// import AssessmentParticipantTable from 'components/threepp/assessment/AssessmentParticipantTable/AssessmentParticipantTable';
// import Section from 'components/common/Section/Section';
import Questions from 'components/threepp/assessment/Questions/Questions';
import { getFormattedName } from 'selectors/formatName/selector';
import { getCurrentUser as getCurrentUserSelector, hasCurrentUser } from 'selectors/user/selector';
import { getPOJOFromSeachParams, getQueryFilterVariables } from 'selectors/assessmentFilters/selector';
import {
  getIdFromUrlParams,
  getAssessmentProgress,
  getAssessmentAnsweredQuestions,
  getAssessmentTotalQuestions,
  isAssessmentReadOnly as isAssessmentReadOnlySelector,
  getActiveUsersEmails,
  isAssessmentSubmitted,
  getAssessmentParticipantTableData
} from 'selectors/assessment/selector';

import {
  listAssessments,
  getAssessmentById,
  removeParticipantFromAssessment,
  removeCurrentUserFromAssessment,
  getCurrentUser,
  getDDEActions,
  getActiveUsers
} from 'graphql/operations';
import { NETWORK_ONLY } from 'graphql/fetchPolicies';

import './Assessment.scss';
import { Paper } from '@material-ui/core';
import { SidebarWrapper } from 'components/common/SideBar/SidebarWrapper';
import { CategorySidebar } from 'components/threepp/assessment/Filters/CategorySidebar';
import { DeviceWidth, EventEmitterTypes, SidebarViews } from 'utils/constants';
import EventEmitter from 'utils/events';
import { ChevronRight } from '@material-ui/icons';
import { SIDEBAR_TOGGLE_DURATION } from '../../utils/constants';
import { isFetchingAssessment, getAssessment, getDdeActions } from './selector';

export class Assessment extends Component {
  static propTypes = {
    /* eslint-disable react/forbid-prop-types */
    assessment: PropTypes.object,
    assessmentProgress: PropTypes.number,
    assessmentAnsweredQuestions: PropTypes.number,
    assessmentTotalQuestions: PropTypes.number,
    t: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    removeParticipantFromAssessment: PropTypes.func.isRequired,
    removeCurrentUserFromAssessment: PropTypes.func.isRequired,
    currentUser: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired
    /* eslint-enable react/forbid-prop-types */
  };

  static defaultProps = {
    assessment: null,
    assessmentProgress: 0,
    assessmentAnsweredQuestions: 0,
    assessmentTotalQuestions: 0
  };

  constructor(props) {
    super(props);
    this.state = {
      showParticipantModal: false,
      openSidebar: false,
      showRemoveUserConfirmationDialog: false,
      removeUserMessage: '',
      userToRemove: null,
      userForUpdate: null,
      uploadAttachmentProgressCount: 0,
      sidebarView: SidebarViews.OVERVIEW,
      isMobile: false,
      panelExpanded: true,
      showToggleArrow: false,
      showRefreshPendingMsg: false,
      triggerGuidedTour:
        localStorage.getItem(SHOW_ASSESSMENT_GUIDED_TOUR_KEY) === null ? true : JSON.parse(localStorage.getItem(SHOW_ASSESSMENT_GUIDED_TOUR_KEY)),
      selectedCategoryOrder: 1,
      visibleCategoryId: null
    };
  }

  setTriggerGuidedTour = () => {
    const guidedTourState = JSON.parse(localStorage.getItem(SHOW_ASSESSMENT_GUIDED_TOUR_KEY));
    this.setState({ triggerGuidedTour: guidedTourState });
  };

  resize = () => this.setState({ isMobile: window.innerWidth <= DeviceWidth.MOBILE });

  componentDidMount() {
    this.resize();
    window.addEventListener('resize', this.resize);
    EventEmitter.subscribe(EventEmitterTypes.TOGGLE_ADD_PARTICIPANTS, ({ openSidebar }) => this.toggleAddParticipantsModal(openSidebar));
    EventEmitter.subscribe(EventEmitterTypes.TOGGLE_VISIBLE_CATEGORY, ({ categoryId }) => this.setVisibleCategory(categoryId));
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resize);
    EventEmitter.unsubscribe(EventEmitterTypes.TOGGLE_ADD_PARTICIPANTS);
    EventEmitter.unsubscribe(EventEmitterTypes.TOGGLE_VISIBLE_CATEGORY);
  }

  incrementAttachmentUploadCount = () => {
    const { uploadAttachmentProgressCount } = this.state;
    this.setState({ uploadAttachmentProgressCount: uploadAttachmentProgressCount + 1 });
  };

  decrementAttachmentUploadCount = () => {
    const { uploadAttachmentProgressCount } = this.state;
    this.setState({ uploadAttachmentProgressCount: uploadAttachmentProgressCount - 1 });
  };

  onConfirmDelete = () => {
    const { userToRemove } = this.state;
    const {
      t,
      currentUser,
      history,
      assessment,
      removeCurrentUserFromAssessment: propsRemoveCurrentUserFromAssessment,
      removeParticipantFromAssessment: propsRemoveParticipantFromAssessment
    } = this.props;

    this.setState(
      {
        showRemoveUserConfirmationDialog: false,
        removeUserMessage: '',
        userToRemove: null
      },
      () => {
        const { showRemoveUserConfirmationDialog } = this.state;
        if (userToRemove.email === currentUser.email) {
          propsRemoveCurrentUserFromAssessment({
            variables: {
              assessmentId: assessment.id
            },
            update: store => {
              // Remove assessment from cache when removing current user
              const ds = store.readQuery({ query: listAssessments });
              const assessments = ds.listAssessments;
              const assessmentIndex = assessments.findIndex(a => a.id === assessment.id);
              const updatedAssessmentList = [...assessments.slice(0, assessmentIndex), ...assessments.slice(assessmentIndex + 1)];
              store.writeQuery({ query: listAssessments, data: { listAssessments: updatedAssessmentList } });
            }
          })
            .then(() => {
              showSuccessMessage(t('assessment.removeParticipant.successMsg', { name: getFormattedName({ user: userToRemove }) }));
              history.push(Routes.home.path);
            })
            .catch(() => {
              showErrorMessage(t('assessment.removeParticipant.errorMsg'));
              this.toggleSidebar(!showRemoveUserConfirmationDialog, SIDEBAR_TOGGLE_DURATION);
            });
        } else {
          propsRemoveParticipantFromAssessment({
            variables: {
              assessmentId: assessment.id,
              email: userToRemove.email
            }
          })
            .then(() => {
              showSuccessMessage(t('assessment.removeParticipant.successMsg', { name: getFormattedName({ user: userToRemove }) }));
            })
            .catch(() => {
              showErrorMessage(t('assessment.removeParticipant.errorMsg'));
            })
            .finally(() => this.toggleSidebar(!showRemoveUserConfirmationDialog, SIDEBAR_TOGGLE_DURATION));
        }
      }
    );
  };

  handleCloseRemoveUserDialog = () => {
    const { showRemoveUserConfirmationDialog } = this.state;
    this.toggleSidebar(showRemoveUserConfirmationDialog, 0);
    this.setState({
      showRemoveUserConfirmationDialog: false,
      removeUserMessage: '',
      userToRemove: null
    });
  };

  handleRemoveUserFromAssessment = user => {
    const { t } = this.props;
    const { showRemoveUserConfirmationDialog } = this.state;
    this.toggleSidebar(showRemoveUserConfirmationDialog, 0);
    this.setState({
      showRemoveUserConfirmationDialog: true,
      removeUserMessage: t('assessment.removeParticipant.prompt', { name: getFormattedName({ user }) }),
      userToRemove: user
    });
  };

  toggleSidebar = (open, timeout) => {
    const { isMobile } = this.state;
    isMobile &&
      setTimeout(() => {
        EventEmitter.dispatch(EventEmitterTypes.TOGGLE_MOBILE_SIDEBAR, { right: 'right', open });
      }, timeout);
  };

  togglePanel = () =>
    this.setState(prevState => ({
      panelExpanded: !prevState.panelExpanded,
      showToggleArrow: !prevState.showToggleArrow,
      sidebarView: ''
    }));

  toggleArrowIcon = () => this.setState(prevState => ({ showToggleArrow: !prevState.showToggleArrow }));

  handleUpdateUser = user => {
    const { showParticipantModal } = this.state;
    this.toggleSidebar(showParticipantModal, 0);
    this.setState(prevState => ({
      showParticipantModal: !prevState.showParticipantModal,
      userForUpdate: user
    }));
  };

  toggleAddParticipantsModal = openSidebar => {
    this.setState(prevState => ({
      showParticipantModal: !prevState.showParticipantModal,
      openSidebar,
      userForUpdate: null
    }));
  };

  handleIconClick = sidebarView => {
    const { panelExpanded } = this.state;
    if (!panelExpanded) {
      this.setState({ panelExpanded: true });
    }
    this.setState({ sidebarView });
  };

  handleTriggeredActionsInfo = (triggered, hasRequired) => {
    this.setState({ showActionsTriggeredMsg: triggered, showRefreshPendingMsg: hasRequired });
  };

  setSelectedCategory = categoryOrder => {
    this.setState({ selectedCategoryOrder: categoryOrder });
  };

  setVisibleCategory = categoryId => {
    this.setState({ visibleCategoryId: categoryId });
  };

  updateCurrentCategory = currentCategory => {
    this.setState({ currentCategory });
  };

  render() {
    const {
      t,
      isLoading,
      assessment,
      assessmentProgress,
      isAssessmentReadOnly,
      assessmentAnsweredQuestions,
      assessmentTotalQuestions,
      // isAssessmentReadOnly,
      currentUser,
      assessmentError,
      actions,
      activeUsers,
      getCurrentUser: propsGetCurrentUser
    } = this.props;
    const {
      showRemoveUserConfirmationDialog,
      removeUserMessage,
      uploadAttachmentProgressCount,
      sidebarView,
      isMobile,
      triggerGuidedTour,
      showToggleArrow,
      panelExpanded,
      selectedCategoryOrder,
      showActionsTriggeredMsg,
      currentCategory,
      visibleCategoryId,
      openSidebar,
      showParticipantModal,
      userForUpdate,
      showRefreshPendingMsg
    } = this.state;
    const participantsData = getAssessmentParticipantTableData({ assessment, actions });
    if (isLoading) {
      return <LoadingPage size="lg" expanded />;
    }

    if (assessmentError) {
      return <div className="assessment-error">{t('assessment.error')}</div>;
    }

    if (!assessment) {
      return <div className="assessment-error">{t('assessment.notFound')}</div>;
    }

    const assessmentHelpText = assessment.helpText;
    const isOwner = hasCurrentUser({ assessment, users: assessment.owners, getCurrentUser: propsGetCurrentUser });
    const filterVariables = getPOJOFromSeachParams(this.props);
    const isSubmitted = isAssessmentSubmitted(assessment.status);
    return (
      <React.Fragment>
        {triggerGuidedTour && <AssessmentGuidedTour setTriggerGuidedTour={this.setTriggerGuidedTour} isMobile={isMobile} />}
        <AssessmentSubscriber showActionsTriggeredInfo={this.handleTriggeredActionsInfo} />
        <ConfirmationDialog
          title={t('assessment.removeParticipant.title')}
          open={showRemoveUserConfirmationDialog}
          message={removeUserMessage}
          onYes={this.onConfirmDelete}
          onNo={this.handleCloseRemoveUserDialog}
        />
        <InviteParticipantModal
          editUser={userForUpdate}
          onAssigneesChanged={() => {}}
          toggle={this.toggleAddParticipantsModal}
          isOpen={showParticipantModal}
          openSidebar={openSidebar}
        />

        <AssessmentNavBar
          assessmentName={assessment.name}
          assessmentCompanyName={assessment.company}
          onIconClick={this.handleIconClick}
          sidebarView={sidebarView}
          filterVariables={filterVariables}
          activeUsers={getActiveUsersEmails(activeUsers, propsGetCurrentUser)}
          submitted={isAssessmentSubmitted(assessment.status)}
          assessmentProgress={assessmentProgress}
        />

        <div className="assessment-page assessment-row">
          {!isMobile && (
            <section className="left-panel col-md-3">
              <Paper className="sticky-sidebar" square>
                <CategorySidebar
                  className="CategorySidebar"
                  assessment={assessment}
                  actions={actions}
                  selectedCategory={this.setSelectedCategory}
                  visibleCategory={visibleCategoryId}
                  currentCategory={currentCategory}
                />
              </Paper>
            </section>
          )}
          <section
            className={`assessment-section ${!isMobile ? 'col-md-6' : ''} ${panelExpanded ? '' : 'panel-collapsed'} ${
              isSubmitted ? 'submitted' : 'open'
            }`}
          >
            <Paper elevation={2} className="assessment-body-wrapper">
              <div className="assessment-header-wrapper">
                <div className={isSubmitted ? 'assessment-header' : ''}>
                  <AssessmentHeader
                    assessmentHelpText={assessmentHelpText}
                    assessment={assessment}
                    assessmentProgress={assessmentProgress}
                    currentUser={currentUser}
                    assessmentAnsweredQuestions={assessmentAnsweredQuestions}
                    assessmentTotalQuestions={assessmentTotalQuestions}
                    participantsData={participantsData}
                    isAssessmentDisabled={isAssessmentReadOnly}
                    isOwner={isOwner}
                    onDeleteUser={this.handleRemoveUserFromAssessment}
                    onUpdateUser={this.handleUpdateUser}
                    filterVariables={filterVariables}
                    setTriggerGuidedTour={this.setTriggerGuidedTour}
                    actions={actions}
                    selectedCategory={this.setSelectedCategory}
                    visibleCategory={visibleCategoryId}
                    activeUsers={getActiveUsersEmails(activeUsers, propsGetCurrentUser)}
                    currentCategory={currentCategory}
                  />
                </div>
              </div>
              {showActionsTriggeredMsg && <ActionsInfoHeader />}
              <div className="assessment-body">
                {/* <Section
                className='assessment-section'
                name={(
                  <span className='participants-header'>
                    <span>
                      {t('assessment.sectionParticipants')}
                    </span>
                    {
                      !isAssessmentReadOnly
                        ? (
                          <Tooltip title={t('assessment.addParticipants')} placement='right'>
                            <AddIcon
                              className='add-participant'
                              onClick={this.toggleAddParticipantsModal}
                            />
                          </Tooltip>
                        )
                        : null
                    }
                  </span>
                )}
              >
                <AssessmentParticipantTable
                  assessment={assessment}
                  onDeleteUser={this.handleRemoveUserFromAssessment}
                  onUpdateUser={this.handleUpdateUser}
                />
              </Section> */}

                {/* <Section
                className='assessment-section'
                name={t('assessment.sectionQuestions')}
              > */}
                <div className="questions-section">
                  <Questions
                    assessment={assessment}
                    actions={actions}
                    selectedCategoryOrder={selectedCategoryOrder}
                    incrementAttachmentUploadCount={this.incrementAttachmentUploadCount}
                    decrementAttachmentUploadCount={this.decrementAttachmentUploadCount}
                    currentUser={currentUser}
                    updateCurrentCategory={this.updateCurrentCategory}
                  />
                </div>
                {/* </Section> */}
              </div>
            </Paper>
          </section>
          <section className="right-panel col-md-3">
            {!isMobile && panelExpanded && (
              <Paper className="sticky-sidebar" square>
                <div className="panel-toggle-arrow" onMouseEnter={this.toggleArrowIcon} onMouseLeave={this.toggleArrowIcon}>
                  {showToggleArrow && (
                    <div className="toggle-arrow-container">
                      <ChevronRight className="arrow-icon" onClick={this.togglePanel} />
                    </div>
                  )}
                </div>
                <SidebarWrapper
                  assessment={assessment}
                  activeUsers={getActiveUsersEmails(activeUsers, propsGetCurrentUser)}
                  assessmentHelpText={assessmentHelpText}
                  assessmentProgress={assessmentProgress}
                  assessmentAnsweredQuestions={assessmentAnsweredQuestions}
                  assessmentTotalQuestions={assessmentTotalQuestions}
                  sidebarView={sidebarView}
                  participantsData={participantsData}
                  currentUser={currentUser}
                  isAssessmentDisabled={isAssessmentReadOnly}
                  isOwner={isOwner}
                  onDeleteUser={this.handleRemoveUserFromAssessment}
                  onUpdateUser={this.handleUpdateUser}
                  open={false}
                  setTriggerGuidedTour={this.setTriggerGuidedTour}
                />
              </Paper>
            )}
          </section>
          <AssessmentFooter
            actions={actions}
            panelExpanded={panelExpanded}
            assessment={assessment}
            attachmentUploadCount={uploadAttachmentProgressCount}
            isMobile={isMobile}
            showRefreshPendingMsg={showRefreshPendingMsg}
            triggerGuidedTour={triggerGuidedTour}
          />
        </div>
      </React.Fragment>
    );
  }
}

export const AssessmentHOC = compose(
  withTranslation(),
  withRouter,
  graphql(getCurrentUser, { name: 'getCurrentUser' }),
  graphql(getDDEActions, {
    options: props => ({
      variables: {
        id: getIdFromUrlParams(props)
      },

      fetchPolicy: NETWORK_ONLY
    }),
    name: 'getDDEActions'
  }),
  graphql(getAssessmentById, {
    options: props => ({
      variables: {
        id: getIdFromUrlParams(props)
      },
      fetchPolicy: NETWORK_ONLY
    })
  }),
  graphql(getActiveUsers, {
    options: props => ({
      variables: {
        id: getIdFromUrlParams(props)
      },
      fetchPolicy: NETWORK_ONLY
    }),
    name: 'getActiveUsers'
  }),
  graphql(removeParticipantFromAssessment, {
    options: props => ({
      refetchQueries: () => [
        {
          query: getAssessmentById,
          variables: {
            id: getIdFromUrlParams(props),
            fieldsFilter: getQueryFilterVariables(props)
          }
        }
      ],
      awaitRefetchQueries: true
    }),
    name: 'removeParticipantFromAssessment'
  }),
  graphql(removeCurrentUserFromAssessment, {
    options: props => ({
      refetchQueries: () => [
        {
          query: getAssessmentById,
          variables: {
            id: getIdFromUrlParams(props),
            fieldsFilter: getQueryFilterVariables(props)
          }
        }
      ],
      awaitRefetchQueries: true
    }),
    name: 'removeCurrentUserFromAssessment'
  }),
  mapProps(props => {
    const assessment = getAssessment(props);
    const actions = getDdeActions(props);
    return {
      t: props.t,
      history: props.history,
      assessment,
      actions,
      assessmentError: props.data.error,
      assessmentProgress: getAssessmentProgress({ assessment, actions }),
      assessmentAnsweredQuestions: getAssessmentAnsweredQuestions({ assessment, actions }),
      assessmentTotalQuestions: getAssessmentTotalQuestions({ assessment, actions }),
      isLoading: isFetchingAssessment(props),
      removeParticipantFromAssessment: props.removeParticipantFromAssessment,
      removeCurrentUserFromAssessment: props.removeCurrentUserFromAssessment,
      currentUser: getCurrentUserSelector(props),
      getCurrentUser: props.getCurrentUser,
      isAssessmentReadOnly: isAssessmentReadOnlySelector({ assessment }),
      activeUsers: props.getActiveUsers?.getActiveUsers
    };
  })
);

export default AssessmentHOC(Assessment);
